// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.VenueTopInstitutions_venue-top-institutions__T7\\+ja .VenueTopInstitutions_inst__EnbhH {
  display: flex;
  margin-bottom: 25px;
  border-radius: 8px;
  border: 1px solid var(--accent-color-light);
  box-shadow: 0 0 rgba(0, 0, 0, 0), 0 0 rgba(0, 0, 0, 0), 0 1px 2px 0 rgba(0, 0, 0, 0.05);
}
.VenueTopInstitutions_venue-top-institutions__T7\\+ja .VenueTopInstitutions_inst__left__b9wNF {
  min-width: 80px;
  min-height: 130px;
}
.VenueTopInstitutions_venue-top-institutions__T7\\+ja .VenueTopInstitutions_inst__left__b9wNF .VenueTopInstitutions_ranking__Y\\+MQw {
  width: 100%;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--accent-color-light);
  font-size: 14px;
  color: var(--light-pink);
  font-weight: bold;
}
.VenueTopInstitutions_venue-top-institutions__T7\\+ja .VenueTopInstitutions_inst__left__b9wNF .VenueTopInstitutions_ranking--index__Ks2HF {
  font-size: 20px;
  color: var(--accent-color-dark);
}
.VenueTopInstitutions_venue-top-institutions__T7\\+ja .VenueTopInstitutions_inst__right__Dc3TX {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  padding: 24px;
  gap: 8px;
}
.VenueTopInstitutions_venue-top-institutions__T7\\+ja .VenueTopInstitutions_inst__right__top__mmtiL {
  display: flex;
  gap: 8px;
}
.VenueTopInstitutions_venue-top-institutions__T7\\+ja .VenueTopInstitutions_inst__right__top__mmtiL .VenueTopInstitutions_avatar__4JWWC {
  aspect-ratio: 1/1;
  height: 70px;
  padding: 4px;
  position: relative;
  border: 1px solid var(--light-grey);
  border-radius: 12px;
  overflow: hidden;
}
.VenueTopInstitutions_venue-top-institutions__T7\\+ja .VenueTopInstitutions_inst__right__top__mmtiL .VenueTopInstitutions_avatar__4JWWC .VenueTopInstitutions_photo__DkP5p {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.VenueTopInstitutions_venue-top-institutions__T7\\+ja .VenueTopInstitutions_inst__right__top__mmtiL .VenueTopInstitutions_avatar__4JWWC .VenueTopInstitutions_check__-PrJh {
  position: absolute;
  width: 20px;
  height: 20px;
  bottom: 0;
  right: -5px;
}
.VenueTopInstitutions_venue-top-institutions__T7\\+ja .VenueTopInstitutions_inst__right__top__mmtiL .VenueTopInstitutions_info__AtIoN {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.VenueTopInstitutions_venue-top-institutions__T7\\+ja .VenueTopInstitutions_inst__right__top__mmtiL .VenueTopInstitutions_info__top__qex3h {
  display: flex;
  justify-content: space-between;
}
.VenueTopInstitutions_venue-top-institutions__T7\\+ja .VenueTopInstitutions_inst__right__top__mmtiL .VenueTopInstitutions_info__AtIoN .VenueTopInstitutions_name__Sd60B {
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
}
.VenueTopInstitutions_venue-top-institutions__T7\\+ja .VenueTopInstitutions_inst__right__top__mmtiL .VenueTopInstitutions_info__AtIoN .VenueTopInstitutions_name__Sd60B:hover {
  text-decoration: underline;
  color: var(--blue);
}
.VenueTopInstitutions_venue-top-institutions__T7\\+ja .VenueTopInstitutions_inst__right__top__mmtiL .VenueTopInstitutions_info__AtIoN .VenueTopInstitutions_score__prJ71 {
  display: flex;
  align-items: center;
}
.VenueTopInstitutions_venue-top-institutions__T7\\+ja .VenueTopInstitutions_inst__right__top__mmtiL .VenueTopInstitutions_info__AtIoN .VenueTopInstitutions_inst-name__fWeFY {
  font-size: 18px;
  color: var(--dark-grey);
  font-weight: 600;
}
.VenueTopInstitutions_venue-top-institutions__T7\\+ja .VenueTopInstitutions_inst__right__top__mmtiL .VenueTopInstitutions_info__AtIoN .VenueTopInstitutions_inst-name__fWeFY:hover {
  text-decoration: underline;
}
.VenueTopInstitutions_venue-top-institutions__T7\\+ja .VenueTopInstitutions_inst__right__top__mmtiL .VenueTopInstitutions_info__AtIoN .VenueTopInstitutions_bio__cFAla {
  font-size: 14px;
  color: var(--dark-grey);
}
.VenueTopInstitutions_venue-top-institutions__T7\\+ja .VenueTopInstitutions_inst__right__top__mmtiL .VenueTopInstitutions_info__AtIoN .VenueTopInstitutions_tags__CIX06 {
  margin-bottom: 5px;
}
.VenueTopInstitutions_venue-top-institutions__T7\\+ja .VenueTopInstitutions_inst__right__bottom__I2urW {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.VenueTopInstitutions_venue-top-institutions__T7\\+ja .VenueTopInstitutions_inst__right__bottom__I2urW .VenueTopInstitutions_statistics__s6IAM {
  display: flex;
  gap: 12px;
}
.VenueTopInstitutions_venue-top-institutions__T7\\+ja .VenueTopInstitutions_inst__right__bottom__I2urW .VenueTopInstitutions_statistics__item__abOVF {
  padding: 4px 8px;
  background-color: #fff;
  border-radius: 10px;
  border: 1px solid var(--light-grey);
  display: flex;
  align-items: center;
  gap: 4px;
}
.VenueTopInstitutions_venue-top-institutions__T7\\+ja .VenueTopInstitutions_inst__right__bottom__I2urW .VenueTopInstitutions_statistics__item--icon__zFneO {
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 9999px;
}
.VenueTopInstitutions_venue-top-institutions__T7\\+ja .VenueTopInstitutions_inst__right__bottom__I2urW .VenueTopInstitutions_statistics__item--icon__zFneO svg {
  width: 16px;
  height: 16px;
}
.VenueTopInstitutions_venue-top-institutions__T7\\+ja .VenueTopInstitutions_inst__right__bottom__I2urW .VenueTopInstitutions_statistics__item--icon__zFneO svg path {
  stroke: var(--accent-color-dark);
}
.VenueTopInstitutions_venue-top-institutions__T7\\+ja .VenueTopInstitutions_inst__right__bottom__I2urW .VenueTopInstitutions_statistics__item--content__RTwaR {
  display: flex;
  align-items: center;
  gap: 4px;
}
.VenueTopInstitutions_venue-top-institutions__T7\\+ja .VenueTopInstitutions_inst__right__bottom__I2urW .VenueTopInstitutions_statistics__item--value__8qW8- {
  color: var(--accent-color-dark);
  font-size: 16;
  font-weight: bold;
}
.VenueTopInstitutions_venue-top-institutions__T7\\+ja .VenueTopInstitutions_inst__right__bottom__I2urW .VenueTopInstitutions_statistics__item--title__YfY5U {
  color: var(--dark-grey);
  font-size: 14px;
}
@media only screen and (max-width: 480px) {
  .VenueTopInstitutions_venue-top-institutions__T7\\+ja .VenueTopInstitutions_inst__EnbhH {
    border: none;
    border-bottom: 1px solid var(--light-grey);
    border-radius: 0;
    box-shadow: none;
    margin-bottom: 10px;
  }
  .VenueTopInstitutions_venue-top-institutions__T7\\+ja .VenueTopInstitutions_inst__left__b9wNF {
    padding-top: 9px;
    min-width: 40px;
    min-height: 65px;
  }
  .VenueTopInstitutions_venue-top-institutions__T7\\+ja .VenueTopInstitutions_inst__left__b9wNF .VenueTopInstitutions_ranking__Y\\+MQw {
    height: 40px;
    font-size: 10px;
  }
  .VenueTopInstitutions_venue-top-institutions__T7\\+ja .VenueTopInstitutions_inst__left__b9wNF .VenueTopInstitutions_ranking--index__Ks2HF {
    font-size: 14px;
  }
  .VenueTopInstitutions_venue-top-institutions__T7\\+ja .VenueTopInstitutions_inst__right__Dc3TX {
    padding: 0 0 12px 12px;
  }
  .VenueTopInstitutions_venue-top-institutions__T7\\+ja .VenueTopInstitutions_inst__right__top__mmtiL .VenueTopInstitutions_avatar__4JWWC {
    min-width: 60px;
    max-width: 60px;
    height: 60px;
  }
  .VenueTopInstitutions_venue-top-institutions__T7\\+ja .VenueTopInstitutions_inst__right__top__mmtiL .VenueTopInstitutions_info__AtIoN {
    gap: 4px;
  }
  .VenueTopInstitutions_venue-top-institutions__T7\\+ja .VenueTopInstitutions_inst__right__top__mmtiL .VenueTopInstitutions_info__AtIoN .VenueTopInstitutions_name__Sd60B {
    font-size: 16px;
  }
  .VenueTopInstitutions_venue-top-institutions__T7\\+ja .VenueTopInstitutions_inst__right__top__mmtiL .VenueTopInstitutions_info__AtIoN .VenueTopInstitutions_score__prJ71 {
    font-size: 12px;
  }
  .VenueTopInstitutions_venue-top-institutions__T7\\+ja .VenueTopInstitutions_inst__right__top__mmtiL .VenueTopInstitutions_info__AtIoN .VenueTopInstitutions_score__prJ71 svg {
    width: 16px;
    height: 16px;
  }
  .VenueTopInstitutions_venue-top-institutions__T7\\+ja .VenueTopInstitutions_inst__right__top__mmtiL .VenueTopInstitutions_info__AtIoN .VenueTopInstitutions_score__prJ71 span {
    display: none;
  }
  .VenueTopInstitutions_venue-top-institutions__T7\\+ja .VenueTopInstitutions_inst__right__top__mmtiL .VenueTopInstitutions_info__AtIoN .VenueTopInstitutions_inst-name__fWeFY {
    font-size: 12px;
  }
  .VenueTopInstitutions_venue-top-institutions__T7\\+ja .VenueTopInstitutions_inst__right__Dc3TX .ant-tag {
    font-size: 8px;
    line-height: 16px;
  }
}`, "",{"version":3,"sources":["webpack://./src/Explore/Pages/VenueDetail/Components/VenueTopInstitutions/VenueTopInstitutions.module.scss"],"names":[],"mappings":"AACE;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,2CAAA;EACA,uFAAA;AAAJ;AAEI;EACE,eAAA;EACA,iBAAA;AAAN;AAEM;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,2CAAA;EACA,eAAA;EACA,wBAAA;EACA,iBAAA;AAAR;AAEQ;EACE,eAAA;EACA,+BAAA;AAAV;AAKI;EACE,SAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;EACA,QAAA;AAHN;AAKM;EACE,aAAA;EACA,QAAA;AAHR;AAKQ;EACE,iBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,mCAAA;EACA,mBAAA;EACA,gBAAA;AAHV;AAKU;EACE,WAAA;EACA,YAAA;EACA,mBAAA;AAHZ;AAMU;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,WAAA;AAJZ;AAQQ;EACE,SAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AANV;AAQU;EACE,aAAA;EACA,8BAAA;AANZ;AASU;EACE,eAAA;EACA,gBAAA;EACA,eAAA;AAPZ;AASY;EACE,0BAAA;EACA,kBAAA;AAPd;AAWU;EACE,aAAA;EACA,mBAAA;AATZ;AAYU;EACE,eAAA;EACA,uBAAA;EACA,gBAAA;AAVZ;AAYY;EACE,0BAAA;AAVd;AAcU;EACE,eAAA;EACA,uBAAA;AAZZ;AAeU;EACE,kBAAA;AAbZ;AAkBM;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAhBR;AAkBQ;EACE,aAAA;EACA,SAAA;AAhBV;AAkBU;EACE,gBAAA;EACA,sBAAA;EACA,mBAAA;EACA,mCAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AAhBZ;AAkBY;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,qBAAA;AAhBd;AAkBc;EACE,WAAA;EACA,YAAA;AAhBhB;AAkBgB;EACE,gCAAA;AAhBlB;AAqBY;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAnBd;AAsBY;EACE,+BAAA;EACA,aAAA;EACA,iBAAA;AApBd;AAuBY;EACE,uBAAA;EACA,eAAA;AArBd;AA6BE;EACE;IACE,YAAA;IACA,0CAAA;IACA,gBAAA;IACA,gBAAA;IACA,mBAAA;EA3BJ;EA6BI;IACE,gBAAA;IACA,eAAA;IACA,gBAAA;EA3BN;EA6BM;IACE,YAAA;IACA,eAAA;EA3BR;EA6BQ;IACE,eAAA;EA3BV;EA+BI;IACE,sBAAA;EA7BN;EAgCQ;IACE,eAAA;IACA,eAAA;IACA,YAAA;EA9BV;EAiCQ;IACE,QAAA;EA/BV;EAgCU;IACE,eAAA;EA9BZ;EAiCU;IACE,eAAA;EA/BZ;EAiCY;IACE,WAAA;IACA,YAAA;EA/Bd;EAiCY;IACE,aAAA;EA/Bd;EAmCU;IACE,eAAA;EAjCZ;EAsCM;IACE,cAAA;IACA,iBAAA;EApCR;AACF","sourcesContent":[".venue-top-institutions {\n  .inst {\n    display: flex;\n    margin-bottom: 25px;\n    border-radius: 8px;\n    border: 1px solid var(--accent-color-light);\n    box-shadow: 0 0 #0000, 0 0 #0000, 0 1px 2px 0 rgb(0 0 0 / 0.05);\n\n    &__left {\n      min-width: 80px;\n      min-height: 130px;\n\n      .ranking {\n        width: 100%;\n        height: 80px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        background-color: var(--accent-color-light);\n        font-size: 14px;\n        color: var(--light-pink);\n        font-weight: bold;\n\n        &--index {\n          font-size: 20px;\n          color: var(--accent-color-dark);\n        }\n      }\n    }\n\n    &__right {\n      flex: 1;\n      display: flex;\n      flex-direction: column;\n      padding: 24px;\n      gap: 8px;\n\n      &__top {\n        display: flex;\n        gap: 8px;\n\n        .avatar {\n          aspect-ratio: 1/1;\n          height: 70px;\n          padding: 4px;\n          position: relative;\n          border: 1px solid var(--light-grey);\n          border-radius: 12px;\n          overflow: hidden;\n\n          .photo {\n            width: 100%;\n            height: 100%;\n            object-fit: contain;\n          }\n\n          .check {\n            position: absolute;\n            width: 20px;\n            height: 20px;\n            bottom: 0;\n            right: -5px;\n          }\n        }\n\n        .info {\n          flex: 1;\n          display: flex;\n          flex-direction: column;\n          gap: 8px;\n\n          &__top {\n            display: flex;\n            justify-content: space-between;\n          }\n\n          .name {\n            font-size: 16px;\n            font-weight: 600;\n            cursor: pointer;\n\n            &:hover {\n              text-decoration: underline;\n              color: var(--blue);\n            }\n          }\n\n          .score {\n            display: flex;\n            align-items: center;\n          }\n\n          .inst-name {\n            font-size: 18px;\n            color: var(--dark-grey);\n            font-weight: 600;\n\n            &:hover {\n              text-decoration: underline;\n            }\n          }\n\n          .bio {\n            font-size: 14px;\n            color: var(--dark-grey);\n          }\n\n          .tags {\n            margin-bottom: 5px;\n          }\n        }\n      }\n\n      &__bottom {\n        display: flex;\n        flex-direction: column;\n        gap: 8px;\n\n        .statistics {\n          display: flex;\n          gap: 12px;\n\n          &__item {\n            padding: 4px 8px;\n            background-color: #fff;\n            border-radius: 10px;\n            border: 1px solid var(--light-grey);\n            display: flex;\n            align-items: center;\n            gap: 4px;\n\n            &--icon {\n              width: 24px;\n              height: 24px;\n              display: flex;\n              align-items: center;\n              justify-content: center;\n              border-radius: 9999px;\n\n              svg {\n                width: 16px;\n                height: 16px;\n\n                path {\n                  stroke: var(--accent-color-dark);\n                }\n              }\n            }\n\n            &--content {\n              display: flex;\n              align-items: center;\n              gap: 4px;\n            }\n\n            &--value {\n              color: var(--accent-color-dark);\n              font-size: 16;\n              font-weight: bold;\n            }\n\n            &--title {\n              color: var(--dark-grey);\n              font-size: 14px;\n            }\n          }\n        }\n      }\n    }\n  }\n\n  @media only screen and (max-width: 480px) {\n    .inst {\n      border: none;\n      border-bottom: 1px solid var(--light-grey);\n      border-radius: 0;\n      box-shadow: none;\n      margin-bottom: 10px;\n\n      &__left {\n        padding-top: 9px;\n        min-width: 40px;\n        min-height: 65px;\n\n        .ranking {\n          height: 40px;\n          font-size: 10px;\n\n          &--index {\n            font-size: 14px;\n          }\n        }\n      }\n      &__right {\n        padding: 0 0 12px 12px;\n\n        &__top {\n          .avatar {\n            min-width: 60px;\n            max-width: 60px;\n            height: 60px;\n          }\n\n          .info {\n            gap: 4px;\n            .name {\n              font-size: 16px;\n            }\n\n            .score {\n              font-size: 12px;\n\n              svg {\n                width: 16px;\n                height: 16px;\n              }\n              span {\n                display: none;\n              }\n            }\n\n            .inst-name {\n              font-size: 12px;\n            }\n          }\n        }\n\n        :global(.ant-tag) {\n          font-size: 8px;\n          line-height: 16px;\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"venue-top-institutions": `VenueTopInstitutions_venue-top-institutions__T7+ja`,
	"inst": `VenueTopInstitutions_inst__EnbhH`,
	"inst__left": `VenueTopInstitutions_inst__left__b9wNF`,
	"ranking": `VenueTopInstitutions_ranking__Y+MQw`,
	"ranking--index": `VenueTopInstitutions_ranking--index__Ks2HF`,
	"inst__right": `VenueTopInstitutions_inst__right__Dc3TX`,
	"inst__right__top": `VenueTopInstitutions_inst__right__top__mmtiL`,
	"avatar": `VenueTopInstitutions_avatar__4JWWC`,
	"photo": `VenueTopInstitutions_photo__DkP5p`,
	"check": `VenueTopInstitutions_check__-PrJh`,
	"info": `VenueTopInstitutions_info__AtIoN`,
	"info__top": `VenueTopInstitutions_info__top__qex3h`,
	"name": `VenueTopInstitutions_name__Sd60B`,
	"score": `VenueTopInstitutions_score__prJ71`,
	"inst-name": `VenueTopInstitutions_inst-name__fWeFY`,
	"bio": `VenueTopInstitutions_bio__cFAla`,
	"tags": `VenueTopInstitutions_tags__CIX06`,
	"inst__right__bottom": `VenueTopInstitutions_inst__right__bottom__I2urW`,
	"statistics": `VenueTopInstitutions_statistics__s6IAM`,
	"statistics__item": `VenueTopInstitutions_statistics__item__abOVF`,
	"statistics__item--icon": `VenueTopInstitutions_statistics__item--icon__zFneO`,
	"statistics__item--content": `VenueTopInstitutions_statistics__item--content__RTwaR`,
	"statistics__item--value": `VenueTopInstitutions_statistics__item--value__8qW8-`,
	"statistics__item--title": `VenueTopInstitutions_statistics__item--title__YfY5U`
};
export default ___CSS_LOADER_EXPORT___;
